import { cn } from "@/lib/utils";

interface RichTextContentProps {
    /**
     * Rich text HTML that has ALREADY been sanitized on the server
     * (`sanitizeRichText` from `@/lib/sanitize-html.server`). This component is
     * presentational only — it deliberately does not import the sanitizer so it can be
     * rendered from client components without pulling a parser into the browser bundle.
     */
    html?: string | null;
    className?: string;
}

/**
 * Renders editor-authored property/blog copy. The `rich-text` class carries the
 * published typography (headings, lists, tables, highlights) defined in globals.css,
 * so search engines see real semantic markup instead of a flat paragraph.
 */
export function RichTextContent({ html, className }: RichTextContentProps) {
    if (!html) return null;

    return (
        <div
            className={cn("rich-text", className)}
            dangerouslySetInnerHTML={{ __html: html }}
        />
    );
}
